import { render, staticRenderFns } from "./202312.vue?vue&type=template&id=e815c076&scoped=true&"
import script from "./202312.vue?vue&type=script&lang=js&"
export * from "./202312.vue?vue&type=script&lang=js&"
import style0 from "./202312.vue?vue&type=style&index=0&id=e815c076&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e815c076",
  null
  
)

export default component.exports